<ion-grid>
  <ion-row class="margin-bottom-m">
    <ion-col class="ion-no-padding cart-without-stock-header" size="12">
      <section class="cart-without-stock-icon">
        <ion-icon color="getm-primary-default" name="getm-cart"></ion-icon>
      </section>
      <ion-text class="cart-without-stock-title">
        {{ modalData.title }}
      </ion-text>
      <ion-button
        class="close-button"
        color="getm-background-light-blue"
        (click)="onClose()"
        fill="solid"
        shape="round"
      >
        <ion-icon
          name="getm-close"
          class="close-icon"
          slot="icon-only"
        ></ion-icon>
      </ion-button>
    </ion-col>
  </ion-row>
  <ion-row class="margin-bottom-l">
    <ion-col class="ion-no-padding" size="12">
      <ion-text class="cart-without-stock-body">
        {{ modalData.content }}
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col class="ion-no-padding" size="12">
      <getm-button
        [text]="modalData.button"
        color="tertiary"
        size="large"
        expand="block"
        (click)="onClose()"
      ></getm-button>
    </ion-col>
  </ion-row>
</ion-grid>
